import { Box } from '@mui/material'
import LoginForm from '~/src/components/auth/login/LoginForm'
import Title from '~/src/components/mui-wrappers/Title'
import { useTranslations } from '~/src/hooks/useTranslations'

const LoginContainer = () => {
  const { t } = useTranslations()

  return (
    <>
      <Box>
        <Title variant='h3'>
          {t('auth.log_in')}
        </Title>
        <Title variant='h6'>
          {t('auth.log_in_to_finalize_your_order')}
        </Title>
      </Box>
      <LoginForm />
    </>
  )
}

export default LoginContainer
